import {gql} from '@apollo/client';
import {PopReviewDetail} from '../types/PopReviewType';
import {POP_REVIEW_ITEM_FIELDS} from './getPopReviewPageList';

/**
 * POP 审核详情（含照片预签名 URL 与揽收侧信息）
 *
 * 照片 URL 有效期 10 分钟。后端另有 logs / reasonRounds，此处不取：
 * 详情页不展示操作日志，失败原因已在审核区回显。
 */
export const GET_POP_REVIEW_DETAIL_BY_ID = gql`
    ${POP_REVIEW_ITEM_FIELDS}
    query GetPopReviewDetailById($reviewTaskId: String!) {
        getPopReviewDetailById(reviewTaskId: $reviewTaskId) {
            item {
                ...PopReviewItemFields
            }
            pickupInfo {
                siteName
                address
                zipcode
                contactName
                contactPhone
                channelName
                taskNumber
                routeName
            }
            popPhotoUrls
        }
    }
`;

export interface GetPopReviewDetailByIdResponse {
    getPopReviewDetailById?: PopReviewDetail;
}

export interface GetPopReviewDetailByIdInput {
    reviewTaskId: string;
}
